import DefaultElementNodeType from '../DefaultElementNodeType';
import {BUSINESS_COLLABORATION} from '../../metamodel/Concept';

export default class BusinessCollaborationNodeType extends DefaultElementNodeType {
	static get typeName() {
		return BUSINESS_COLLABORATION;
	}
}
